// Where a play's intents go (docs/05-Tools/Level Designer.md, Playtest):
// normally the Worker, which keeps the record and verifies every word; in a
// playtest, a local backend that answers from the shared core alone. The
// session talks to whichever is set and never knows the difference.
import { api } from '../api/client';
import type { PlayLevel } from '@wits/core';
import type { AlignResponse, FinishResponse, PlayRecord, RemoveResponse, WordResponse } from '../api/types';

export interface PlayBackend {
  start(levelId: string, date?: string): Promise<PlayRecord>;
  level(id: string, version: number): Promise<PlayLevel>;
  get(id: string): Promise<PlayRecord>;
  word(id: string, nodes: number[]): Promise<WordResponse>;
  remove(id: string, word: string): Promise<RemoveResponse>;
  /** The alignment chosen for a surrounded planet (docs/02-Game-Design/Alignments.md). */
  align(id: string, planet: number, alignment: string): Promise<AlignResponse>;
  finish(id: string): Promise<FinishResponse>;
}

export const serverBackend: PlayBackend = {
  start: (levelId, date) => api.startPlay(levelId, date),
  level: (id, version) => api.level(id, version),
  get: (id) => api.getPlay(id),
  word: (id, nodes) => api.submitWord(id, nodes),
  remove: (id, word) => api.removeWord(id, word),
  align: (id, planet, alignment) => api.alignPlanet(id, planet, alignment),
  finish: (id) => api.finishPlay(id),
};

let current: PlayBackend = serverBackend;

export function playBackend(): PlayBackend {
  return current;
}

export function setPlayBackend(backend: PlayBackend | null): void {
  current = backend ?? serverBackend;
}

/** A playtest is on while a local backend is set; derived, so no session reset can lose it. */
export function inPlaytest(): boolean {
  return current !== serverBackend;
}
